export const stateName = 'screen';